import { Box } from '@chakra-ui/react';
import { Grid, gridConfig, Image } from '@time-line/components/common';
import type { AnchorBlock } from 'components/heros/AnchorCtas';
import type { HeroPromotionV2 } from 'types/cms/HeroPromotionV2';

import { Content } from './Content';
import { Header } from './Header';
import { Media } from './Media';

export interface PromotionHeroV2Props extends HeroPromotionV2 {
  title: string;
  anchorBlock?: AnchorBlock;
  frontrowMDProductId?: string;
}

export function PromotionHeroV2({
  title,
  overline,
  text,
  cta,
  media,
  productCutout,
  credentialsOverlayImage,
  credentialsIcons,
  credentialsBullets,
  isDoctorRecommended,
  anchorBlock,
  frontrowMDProductId,
}: PromotionHeroV2Props) {
  return (
    <Grid
      as="section"
      className="section--hero"
      withBorder
      borderRadius={gridConfig.gridBorderRadius}
      overflow="hidden"
      mt={{ lg: '3xs' }}
      mb="lg"
    >
      <Grid.Inner gridRowGap={0}>
        <Header gridColumn={{ base: 'span 12', lg: '1 / 7' }} gridRow={1} />

        <Media
          gridColumn={{ base: '1 / -1', lg: '7 / -1' }}
          gridRow={{ base: 2, lg: '1 / span 2' }}
          ml={{ base: `calc(-1 * ${gridConfig.gridPxClamp})`, lg: 0 }}
          mr={`calc(-1 * ${gridConfig.gridPxClamp})`}
          media={media}
          isDoctorRecommended={isDoctorRecommended}
          frontrowMDProductId={frontrowMDProductId}
        />

        <Content
          title={title}
          overline={overline}
          text={text}
          cta={cta}
          frontrowMDProductId={frontrowMDProductId}
          anchorBlock={anchorBlock}
          credentialsOverlayImage={credentialsOverlayImage}
          credentialsIcons={credentialsIcons}
          credentialsBullets={credentialsBullets}
          gridColumn={{ base: 'span 12', lg: '1 / 6' }}
          gridRow={{ base: 3, lg: 2 }}
          pb={{ base: 0, lg: 'lg' }}
        />

        {productCutout && (
          <Box
            gridColumn={{ base: '3 / span 8', lg: '5 / span 4' }}
            gridRow={{ base: 2, lg: '1 / span 2' }}
            alignSelf={{ base: 'end', lg: 'center' }}
            pos="relative"
            zIndex={1}
            pointerEvents="none"
            mb={{ base: '-lg', lg: 0 }}
            transform={{ lg: 'scale(.8)' }}
          >
            <Image
              image={productCutout}
              alt={productCutout.alt || ''}
              builderOptions={{ fill: false }}
              sizes="260px"
              style={{ width: '100%', height: 'auto', objectFit: 'contain' }}
            />
          </Box>
        )}
      </Grid.Inner>
    </Grid>
  );
}
